export enum AuthErrorMessage {
  USERNAME_PASSWORD_REQUIRED = 'Username and password are required',
  INVALID_USERNAME_OR_PASSWORD = 'Invalid username or password',
}
